import { CHECKLIST_SUBMISSION_STATUS } from '../../constants';
import { getLocalTime } from '../time/time';
import { getUserName } from '../user/getUserName';

// Sign-off times keep "7:05" and "pm" together (non-breaking space) when the text wraps.
export const formatChecklistSignOffTime = (timezone, time) => (
	getLocalTime(timezone, time).format('h:mm\u00a0a')
);

export const CHECKLIST_SIGN_OFF_STATE = {
	WAITING: 'waiting',
	SIGNED_OFF: 'signedOff',
};

/**
 * Manager sign-off of a checklist submission: "Waiting for <manager> to sign off" until the
 * selected manager signs off on their phone, then "Signed off by <manager> at <time>".
 * Submissions saved before phone sign-off have no signOffManager; an approved one counts as
 * signed off. Returns null when the submission has no sign-off to show.
 */
export const getChecklistSignOff = (submission, timezone) => {
	if (submission?.status === CHECKLIST_SUBMISSION_STATUS.APPROVED) {
		const byText = submission.approvedBy ? ` by ${getUserName(submission.approvedBy)}` : '';
		const atText = submission.approvedAt
			? ` at ${formatChecklistSignOffTime(timezone, submission.approvedAt)}`
			: '';

		return {
			state: CHECKLIST_SIGN_OFF_STATE.SIGNED_OFF,
			text: `Signed off${byText}${atText}`,
			note: submission.signOffNote || null,
		};
	}

	if (submission?.signOffManager) {
		return {
			state: CHECKLIST_SIGN_OFF_STATE.WAITING,
			text: `Waiting for ${getUserName(submission.signOffManager)} to sign off`,
			note: null,
		};
	}

	return null;
};

// One line for step descriptions: the sign-off text plus the manager's note.
export const getChecklistSignOffDescription = (submission, timezone) => {
	const signOff = getChecklistSignOff(submission, timezone);
	if (!signOff) {
		return null;
	}

	return signOff.note
		? `${signOff.text}. Note: ${signOff.note}`
		: `${signOff.text}.`;
};
